import { Stack, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import { RouteConstants } from '../../../navigation/navigation-types'
import { InvoiceDto, InvoicePaymentType } from '../../../services/api/sharedTypes/Invoice'
import { openInNewTab } from '../../../utils/global-utils'
import TableButtonShow from '../../table/TableButtonShow'
import IssuersCreateDialog from './IssuersCreateDialog'
import IssuersEditDialog from './IssuersEditDialog'

interface CreateInvoiceProps {
    createInvoice?: (
        invoiceIssuerId: string,
        productsText: string,
        orderNumber: string,
        paymentType: InvoicePaymentType,
        issueDate?: Date,
        taxDate?: Date,
        dueDate?: Date,
    ) => void
    onDelete?: (invoiceId: string) => void
    invoice: InvoiceDto | undefined
    hasContactWithEmail?: boolean
    taxDate: Date
}

const CreateInvoice: React.FC<CreateInvoiceProps> = ({
    invoice,
    createInvoice,
    onDelete,
    hasContactWithEmail,
    taxDate,
}: CreateInvoiceProps) => {
    return (
        <Stack height='100%' direction='row' justifyContent='space-between' alignItems='center'>
            {invoice ? (
                <>
                    <Typography
                        variant='body1'
                        color='primary'
                        style={{ textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => openInNewTab(RouteConstants.invoices + '/' + invoice.id)}
                    >
                        Faktura
                    </Typography>
                    <Stack direction='row' spacing={1}>
                        <Link to={RouteConstants.invoices + '/' + invoice.id}>
                            <TableButtonShow />
                        </Link>
                        {onDelete && createInvoice && (
                            <IssuersEditDialog onSend={createInvoice} onDelete={onDelete} invoice={invoice} />
                        )}
                    </Stack>
                </>
            ) : (
                <Typography variant='body2'>
                    Fakturu vygenerujete{' '}
                    <IssuersCreateDialog onSend={createInvoice} hasContactWithEmail={hasContactWithEmail} taxDate={taxDate} />
                    .
                </Typography>
            )}
        </Stack>
    )
}

export default CreateInvoice
